/**
 * Owns a single object URL created via URL.createObjectURL.
 *
 * Creating a new URL automatically revokes the previous one, so services
 * that repeatedly expose a blob (download links, previews) do not leak
 * object URLs between regenerations.
 */
export class ObjectUrlHolder {
  #currentUrl: string | null = null;

  /**
   * Creates an object URL for the blob, revoking the previously held one.
   *
   * @param blob - Blob (or File) to expose as an object URL
   * @returns The newly created object URL
   */
  create(blob: Blob): string {
    this.revoke();
    const objectUrl = URL.createObjectURL(blob);
    this.#currentUrl = objectUrl;
    return objectUrl;
  }

  /**
   * Revokes the currently held object URL, if any.
   */
  revoke(): void {
    if (!this.#currentUrl) {
      return;
    }

    URL.revokeObjectURL(this.#currentUrl);
    this.#currentUrl = null;
  }
}
